import { useMenu } from 'context/MenuContext';
import formatIdentifier from 'utils/formatIdentifier';
import styles from './styles.module.scss';
import CompanyId from 'models/Profile/CompanyId';
import { getCompanyId, getCurrentIdentifier } from 'utils/identifier';
import Product from 'models/Profile/Product';
import Tooltip from 'components/white-tooltip';
import { t } from 'i18next';
import { getPreferredLanguage } from 'utils/preferredLanguage';

type Company = {
  name: string,
  identifier: string,
  pending: boolean,
  hasGroup?: boolean,
  products: Array<Product>,
  companyId: Array<CompanyId>
}

function Company(props: Company): JSX.Element {
  const
    {
      updateCurrentCompany
    } = useMenu();

  const preferredLanguage = getPreferredLanguage();
  const currentIdentifier = getCurrentIdentifier();

  const isCurrentCompany = (): boolean => {
    const isCurrentIdentifier = props.identifier === currentIdentifier;
    const companyId = getCompanyId();

    if (!hasCompanyId(companyId))
      return isCurrentIdentifier;

    return props.companyId.some(x => x.id === companyId) && isCurrentIdentifier;
  };

  const getCurrentCompanyFlag = (): JSX.Element => {
    const divCurrent = <div id={styles['biobar-current']}></div>;
    if (props.identifier !== currentIdentifier)
      return <></>;

    const companyId = getCompanyId();

    if (!hasCompanyId(companyId))
      return divCurrent;

    return props.companyId.some(x => x.id === companyId) ? divCurrent : <></>;
  };

  const hasCompanyId = (companyId: string): boolean => {
    if (!props.companyId || !companyId)
      return false;

    return true;
  };

  const onClick = (): void => {
    updateCurrentCompany(props);
  };

  const CompanyName = (): JSX.Element => {
    const company = <p className={styles['biobar-company-name']}>{props.name}</p>;

    if (props.name.length < 30)
      return company;

    return (
      <Tooltip text={props.name}>
        {company}
      </Tooltip>
    );
  };

  const Identifier = () : JSX.Element => {
    return <p className={`${styles['biobar-company-identifier']}`}>{formatIdentifier(props.identifier, preferredLanguage)}</p>;
  };

  const Pending = (): JSX.Element => {
    if (!props.pending)
      return <></>;

    return <p className={`${styles['biobar-invite-pending']}`}>{t('biobar.profile.companies.new')}</p>;
  };

  return (
    <div
      className={`${styles['biobar-company']} ${props.hasGroup ? styles['biobar-company-group'] : ''}`}
      onClick={onClick}>
      {getCurrentCompanyFlag()}
      <a className={isCurrentCompany() ? styles['biobar-current-company'] : ''}>
        <CompanyName />
        <div className={styles['biobar-company-row']}>
          <Identifier />
          <Pending />
        </div>
      </a>
    </div>
  );
}

export default Company;